import MatkaBetHistory from './MatkaBetResult';

export default MatkaBetHistory;